import { render, staticRenderFns } from "./LightStrip.vue?vue&type=template&id=7df71df6&scoped=true&"
import script from "./LightStrip.vue?vue&type=script&lang=js&"
export * from "./LightStrip.vue?vue&type=script&lang=js&"
import style0 from "./LightStrip.vue?vue&type=style&index=0&id=7df71df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df71df6",
  null
  
)

export default component.exports